// Libs
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import { images } from '~/assets';

type Props = {};

const ContactUsPdf = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Contact Us</Text>
      <View style={styles.viewText}>
        <Image style={styles.icon} src={images.imgCall} />
        <Text style={styles.text}>(289) 723-9827</Text>
      </View>
      <View style={styles.viewText}>
        <Image style={styles.icon} src={images.imgEmail} />
        <Text style={styles.text}>booking@Nobleplumers.com</Text>
      </View>
    </View>
  );
};

export default ContactUsPdf;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  viewText: {
    alignItems: 'center',
    marginTop: 5,
    flexDirection: 'row',
    gap: 5,
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#333333',
    borderBottomWidth: 1,
    borderColor: '#333333',
    paddingBottom: 5,
  },
  icon: {
    width: 12,
    height: 12,
  },
  textTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#333333',
    width: 100,
  },
  text: {
    fontSize: 10,
    color: '#63667A',
  },
});
